import React from 'react';

import CuotasIncentivos from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/List.js';

export default function () {
  return <CuotasIncentivos />;
}
